import styled from "styled-components";
import {flexCreator} from "../hooks/helpers";

export const HeadDropDown = styled.div`
   display: grid;
   grid-template-columns: repeat(12, 1fr);
   grid-template-rows: 1fr;
   grid-column-gap: 0px;
   grid-row-gap: 0px;
   padding: 1em;
`;

export const LeftHead = styled.div`
   grid-area: 1 / 1 / 2 / 3;
   ${flexCreator("start", "start")}
`;

export const TitleHead = styled.div`
   grid-area: 1 / 1 / 2 / 13;
   ${flexCreator("center", "center")}
`;

export const RightHead = styled.div`
   grid-area: 1 / 11 / 2 / 13;
   ${flexCreator("end", "center")}
`;

export const BodyDropDown = styled.div`
   padding-top: 0.5em;
`;

export const ItemStyled = styled.div`
   width: 100%;
   padding: 1em;
   border-bottom: 1px solid rgba(100, 100, 100, 0.2);
   box-sizing: border-box;

   &:last_child {
      border-bottom: none;
   }

   & .row {
      margin: 1.5em 0;

      &:last-child {
         margin-bottom: 0;
      }
   }
   & .section {
      margin-bottom: 1.5em;
   }
`;
